import React from 'react';

import {
  Alert,
  Breakpoints,
  Checkbox,
  TextCustom,
  TextAppearance,
  TextSize,
  TextColor,
  TextWeight,
  TextLineHeight,
} from '@vw-marketing/us-components';

import {
  StyledAddressVerificationErrorContainer,
  StyledAlertIconContainer,
  StyledConfirmationCheckBoxContainer,
} from './styled';

export const AddressVerificationFail = ({
  withoutAddressVerification,
  setWithoutAddressVerification,
  translationHandler
}: {
  withoutAddressVerification: boolean;
  setWithoutAddressVerification: (value: boolean) => void;
  translationHandler: (key: string) => string;
}) => {

  const handleWithoutAddressVerification = (e: any) => {
    const newValue = e.target.checked;
    setWithoutAddressVerification(newValue);
  };

  return (
    <StyledAddressVerificationErrorContainer>
      <StyledAlertIconContainer>
        <Alert />
      </StyledAlertIconContainer>
      <StyledConfirmationCheckBoxContainer>
        <TextCustom
          appearance={TextAppearance.copy200}
          style={{
            [Breakpoints.default]: {
              fontSize: TextSize.TextSize16,
              color: TextColor.primary,
              fontWeight: TextWeight.regular,
              lineHeight: TextLineHeight.TextLineHeight24,
            },
          }}
        >
          {translationHandler(
            'registration.form.address.verification.error.label',
          )}
        </TextCustom>
        <Checkbox
          aria-required="true"
          aria-label={translationHandler(
            'registration.form.address.confirmation.label',
          )}
          label={translationHandler(
            'registration.form.address.confirmation.label',
          )}
          required
          onChange={handleWithoutAddressVerification}
          checked={withoutAddressVerification}
          value={'false'}
        />
      </StyledConfirmationCheckBoxContainer>
    </StyledAddressVerificationErrorContainer>
  );
};
